const translation = {
  WelcomeBack: 'مرحبًا بعودتك',
  LoginToContinue: 'سجّل الدخول للمتابعة',
  Login: 'تسجيل الدخول',
  EnterpriseResourcePlanning: 'تخطيط موارد المؤسسة',
  LoggingIn: 'جاري تسجيل الدخول...',
  ForgotPassword: 'هل نسيت كلمة المرور؟',
  NeatixErp: 'الحل المتقن',
  AllRightsReserved: 'جميع الحقوق محفوظة.',
  EnterUsername: 'أدخل اسم المستخدم',
  EnterPassword: 'أدخل كلمة المرور',

  LoginSuccess: 'تم تسجيل الدخول بنجاح! جارٍ التوجيه...',
  LoginError: 'اسم المستخدم أو كلمة المرور غير صحيحة',
  ServerError: 'خطأ في الخادم، يرجى المحاولة مرة أخرى لاحقاً',
  NetworkError: 'خطأ في الشبكة، يرجى التحقق من اتصالك',

  Basic_salary: 'الراتب الأساسي',
  Add: 'إضـافة',
  Edit: 'تعديل',
  Dashboard: 'لوحة المعلومات',

  Back: 'عودة للخلف',
  Choose: 'اختــر',

  GeneralSystemLists: 'قوائم النظام العامة',
  NewAssignments: 'تعيين جديد',
  Edit_Aassignment: 'تعديل التعيين',

  Arabic: 'العربية',
  English: 'الانجليزية',
  Turkish: 'التركيـة',
  Change: 'تغيير',
  HomePage: 'الصفحة الرئيسية',
  SystemLanguage: 'لغة النظام',
  ChooseLanguage: 'إختر لغة',
  Language: 'اللغة',

  UpdateData: 'تحديث البيانات',
  UpdateAttendanceData: 'تحديث بيانات الحضور',
  DataUpdatedSuccessfully: 'تم تحديث البيانات بنجاح',
  AttendanceDetails: 'تفاصيــل الحضور',
  AttendanceIndicators: 'مؤشرات الحضور',
  Imprint: 'بصمة',
  Delay: 'تأخير',

  Profile: 'الملف الشخصي',
  logout: 'تسجبل الخروج',
  ChangePassword: 'تغيير كلمة المرور',
  CurrentPassword: 'كلمة المرور الحالية',
  EnterCurrentPassword: 'أدخل كلمة المرور الحالية',
  NewPassword: 'كلمة المرور الجديدة',
  EnterNewPassword: 'أدخل كلمة المرور الجديدة',
  ConfirmNewPassword: ' تأكيد كلمة المرور الجديدة',

  ContainsMoreThan_8_Characters: 'تحتوي على أكثر من 8 أحرف',
  ContainsSpecialCharacters: 'تحتوي على أحرف خاصة',
  ContainAtLeastOneNumber: 'تحتوي على رقم واحد على الأقل.',
  ContainAtLeastOneCapitalLetter: 'تحتوي على حرف كبير واحد على الأقل',
  MatchThePassword: 'تطابق كلمة المرور',

  Yes: 'نعم',
  No: 'لا',
  Confirmation: 'تأكيـد',
  MsgConfirm: 'هل أنت متأكد من عملية الحذف ؟',

  CREATED: 'إنشاء',
  QUESTION: 'سؤال',
  ANSWER: 'إجابة',
  TRANSFER: 'تحويل',
  APPROVED: 'موافقة',
  REJECTED: 'رفض',

  ABSENT: 'غائب',
  LATE: 'متأخر',
  EARLY: 'مبكر',
  FingerprintData: 'بيانات البصمات',

  Image: 'الصورة',
  Welcome: 'مرحبا',
  AddNewEmployee: 'إضافة موظف',
  EmployeeNumber: 'رقم الموظف',
  title: 'اللقب ',
  LocalName: 'الاسم المحلي',
  GlobalName: 'الاسم العالمي ',

  Identity: 'الهوية ',

  SaveSuccess: 'تم حفظ البيانات بنجاح',
  SaveError: 'حدث خطأ أثناء الحفظ',
  RedirectingMessage: 'سيتم توجيهك إلى قائمة الموظفين...',
  UnsavedChangesWarning: 'لديك تغييرات غير محفوظة. هل تريد المغادرة دون الحفظ؟',
  UnsavedChangesAlert: 'لديك تغييرات غير محفوظة',
  LoadingEmployeeData: 'جاري تحميل بيانات الموظف...',
  LoadError: 'خطأ في تحميل البيانات',
  SaveChanges: 'حفظ التغييرات',
  ResetForm: 'إعادة التعيين',
  RequiredFieldsNote: 'الحقول المحددة بعلامة (*) مطلوبة',
  PersonalInformation: 'المعلومات الشخصية',
  AdditionalPersonalInfo: 'معلومات شخصية إضافية',
  FinancialInformation: 'المعلومات المالية',
  ProfilePicture: 'الصورة الشخصية',
  QuickTips: 'نصائح سريعة',
  SaveOftenTip: 'احفظ تغييراتك بشكل متكرر',
  VerifyDataTip: 'تأكد من صحة البيانات قبل الحفظ',
  Age: 'العمر',
  Years: 'سنة',
  IBANFormatWarning: 'يجب أن يبدأ IBAN ببادئة SA',
  Optional: 'اختياري',
  ExtraInfoSaveError: 'خطأ في حفظ المعلومات الإضافية',
  // رسائل الصور
  ImageSizeError: 'حجم الصورة يجب أن لا يتجاوز 5MB',
  ImageTypeError: 'يجب اختيار صورة بصيغة JPEG, PNG, أو JPG',
  ImageRequirements: 'الحجم الأقصى: 1MB، الصيغ المسموحة: JPG, PNG, JPEG',
  RemoveImage: 'إزالة الصورة',
  NoImageSelected: 'لم يتم اختيار صورة',
  EmployeeNumberHelp: 'رقم الموظف لا يمكن تعديله',
  AbsenceAddedSuccessfully: 'تم إضافة سجل الغياب بنجاح',

  endDateAfterStart: 'يجب أن يكون تاريخ النهاية بعد تاريخ البداية',
  Absencehistory: 'سجل الغياب',
  AddAbsence: 'إضافة غياب',
  NoAbsenceRecords: 'لا توجد سجلات غياب',
  viewDetails: 'عرض التفاصيل',
  pending: 'قيد الانتظار',

  AbsenceDetails: 'تفاصيل الغياب',
  NoNotes: 'لا توجد ملاحظات',

  'Marital Status': 'الحالة الإجتماعية ',
  Gender: 'الجنس ',
  DateofBirth: 'تاريخ الميلاد ',
  HiringDate: 'تاريخ التوظيف ',
  BirthCountry: 'دولة الميلاد ',
  Country: 'الدولة',
  CityOfbirth: 'مدينة الميلاد ',
  City: 'المدينة',
  Nationality: 'الجنسية',
  Religion: 'الديانة',
  AnnualLeave: 'الإجازة السنوية',
  Required: 'مطلوب',
  Employees: 'الموظفين',
  Home: 'الرئيسية',
  Search: 'بحـث',
  EmployeeFilter: 'فلتر الموظفين',
  EmployeeStatus: 'حالة الموظف',
  'On-the-job': 'على رأس العمل',
  Terminated: 'تم إنهاؤه',
  NotAssigned: 'لم يتم تعيينه',
  ServiceStartDate: 'تاريخ بداية الخدمة',
  ServiceEndDate: 'تاريخ نهاية الخدمة',
  TotalYears: 'مجموع السنوات',
  TotalMonths: 'مجموع الأشهر',
  TotalDays: 'مجموع الأيام',
  ApprovalDate: 'تاريخ الموافقة',
  ProcedureCompletionDate: 'تاريخ انهاء الإجراءات',
  NoticeDate: 'تاريخ الإشعار',
  TerminationOfService: 'إنهاء الخدمة',
  Delegations: 'التفويضات',
  DelegateFor: 'تفويض لـ',
  DelegateFrom: 'تفويض من',
  Delegate: 'تفويض',

  TotalEmployees: 'إجمالي الموظفين',
  EmployeesOnTheJob: 'الموظفين على رأس العمل',
  EmployeesServicesHaveEnded: 'الموظفين المنتهية خدماتهم ',
  EmployeesOnLeave: 'موظفين في إجـازة',

  EmployeesByDepartment: 'الموظفيــن حسب الإدارة',
  EmployeesByNationality: 'الموظفين حسب الجنسيـة',

  Department: 'الإداره',
  EditDepartment: 'تعديل إدارة',
  Previous: 'السابق',
  Next: 'التالي',
  Save: 'حفـظ',
  Clear: 'مسح',
  Cancel: 'إلغاء',
  Exit: 'خروج',
  Showing: 'عرض',
  Show: 'عرض',
  to: 'إلى',
  of: 'من أصل',
  entries: 'عناصر',

  EntriesVisible: 'عدد السجلات الظاهرة',
  OfTotal: 'من أصل',

  BasicInformation: 'المعلومات الأساسيــة',
  EmployeePhoto: 'صورة الموظف',
  EmployeeModification: 'تعديل موظف',
  EmployeeDetails: 'تفاصيل الموظف',
  Assign: 'التعيين',
  EndOfService: 'نهاية الخدمة',
  'Extra Information': 'معلومات إضافيــة',
  'Extra Information Forms': 'نماذج المعلومات الإضافيــة',

  IsStatic: 'ثابت',
  StaticForms: 'النماذج الثابتة',

  NameOfTheBank: 'اسم البنك',
  ChoosePhoto: 'أختـر صورة',
  PostalCode: 'الرمز البريدي',
  Region: 'المنطقة',

  Record: 'السجل',
  ViewDetails: 'عرض التفاصيل',

  group: 'المجموعة',
  Grade: 'الدرجة الوظيفية',
  AddGrade: 'إضافة درجة وظيفية',
  EditGrade: 'تعديل درجة وظيفية',
  Job: 'الوظيفة',
  EditJob: 'تعديل وظيفة',
  Position: 'المنصب',
  Vacancy: 'الشاغر',
  AddPosition: 'إضافة منصب',
  location: 'الموقع',
  SuperVisor: 'المدير المباشر',
  SuperVisorLevel: 'مستوى المدير المباشر',
  Payroll: 'الراتب',
  Status: 'الحالة',
  'Start Date': 'من تاريخ',
  'Employee Aassignment': 'تعيين موظف',
  CurrentAssignment: 'التعيين الخالي',

  End_Date: 'الى تاريخ',

  Departments: 'الإدارات',
  OrganizationalStructure: 'الهيكل التنظيمي',
  AddDepartment: 'إضافة إدارة',
  InternalOrExternal: 'داخلي / خـارجي',
  External: 'خـارجي',
  Internal: 'داخلي',
  Type: 'النوع',
  Note: 'ملاحظات',
  NoteComplate: 'ملاحظات الإغلاق',
  Classification: 'التصنيف',
  Address: 'العنوان',
  Catagory: 'التصنيف',
  CommercialRegistrationNumber: 'رقم السجل التجاري',
  VatNumber: 'الرقم الضريبي',

  Duration: 'الفترة',

  Reason: 'السبب',
  ChangeDate: 'تاريخ التأثير',
  SalaryValue: 'قيمة الراتب',
  PayrollElementEntry: 'إدخالات عناصر الراتب',
  RunPayrolls: ' مسير الرواتب',
  QuickPay: ' مسير راتب إفرادي',
  Payrolls: 'الرواتب',
  PayrollSettings: 'إعدادات الراتب',
  PayrollElements: 'عناصر الرواتب',
  PayProposalHistory: 'سجل الراتب الأساسي',
  AddPayrollElement: 'إضافة عنصر جديد ',
  EditPayrollElement: 'تعديل عناصر الراتب',
  AddPayroll: 'إضافة راتب',
  UpdatePayroll: 'تعديل راتب',
  TypeOfDuration: 'نوع المدة',
  Name: 'الأسم',
  LinkPayrollElements: 'ربط عناصر الراتب',
  LinkElementsfor: '  ربط العناصر لـ',
  NumberOfyears: 'عدد السنوات',
  NumberOfDays: 'عدد الأيام',
  PaymentMethod: 'طريقة الدفع',
  Date_from: 'من تاريخ',
  Currency: 'العملة',
  Recurring: 'دوري',
  'Non-Recurring': 'غير دوري',
  InputOfType: 'نوع الإدخال',
  Elemente: 'العنصر',
  'Weekly ': 'أسبوعي ',
  Monthly: 'شهري ',
  CreateRunPayrolls: 'إنشاء مسيــر جديــد',
  AddRun: 'إضافة مسيــر',
  CreateRun: 'إنشاء مسيــر',
  ShowAllRuns: 'عرض المسيرات',
  'Period-Month': 'الفترة - الشهر',
  StartOfPeriod: 'بداية الفترة',
  EndOfPeriod: 'نهاية الفترة',
  TypeRunPayroll: 'نوع مسير الرواتب',
  SalaryStatement: 'كشف الراتب',
  Approve: 'موافقة',
  PrintAll: 'طباعة الكـل',
  Print: 'طباعة ',
  PayrollProcessedSuccessfully: 'تمت عملية التسييـر بنجـاح',
  Unpaid: 'غير مدفوع',
  Paid: 'مدفوع',

  Parent: 'الأب',
  child: 'الأبن',

  Icon: 'الأيقونة',
  Forms: 'النماذج',
  SelfServiceForms: 'نماذج الخدمة الذاتية',
  SystemLists: 'قوائم النظام',

  AddValues: 'إضافة قيم',
  Sub_Lists: 'القوائم الفرعية',
  SystemListsAndForms: 'نماذج وقوائم النظام',
  AddForm: 'إضافة نموذج',
  EditForm: 'تعديل نموذج',
  fieldsForm: 'حقول النموذج',
  Form: 'النموذج',
  LetterRequestForm: 'نموذج طلب خطاب',
  AddfieldsForm: 'إضافة حقول النموذج',
  EditfieldsForm: 'تعديل حقول النموذج',
  AddNewList: 'إضافة قائمة جديدة',
  Values: 'القيم',
  'Sub-Lists': 'القوائم الفرعية',
  'Lists&Forms': 'القوائم والنماذج',
  'Value ': 'القيمة',
  tableInTheSystem: 'جدول في النظام',
  GeneralLists: 'القوائم العامة',
  ConstructedList: 'قائمة منشاءة',
  Tables: 'الجداول',
  Table: 'الجدول',

  ApprovalManagement: 'إدارة الموافقات',
  ApprovalGroup: 'مجموعة الموافقات',
  AddGroup: 'إضافة مجموعة',
  AddNewGroup: 'إضافة مجموعة موافقات جدبدة',
  EditGroup: 'تعديـل مجموعة موافقات',
  CountMembers: 'عدد الأعضاء',

  RequestSettings: 'إعدادات الطلبات',
  FollowRequests: 'متابعة الطلبات',
  RequestsTracking: 'متابعة الطلبات',
  RequestForms: 'نماذج الطلبات',
  RequestRules: 'قواعد الطلب',
  RuleConditions: 'شروط القاعدة',
  NotificationSettings: 'إعدادات الإشعار',
  MessageText: 'نص الرسالة',
  HintMessageText: 'اكتب @ لظهور المتغيرات المتاحة',
  HintMessageText1: "عند كتابة  '@'  في النص، ستظهر لك الأعمدة التي تم اختيارها لتضمينها في رسالة الإشعار.",
  TypeNotification: 'نوع الإشعار',
  SystemNotification: ' إشعار نظام',
  smsMessage: 'رسالة sms',
  WhatsAppMessage: '  رسالة واتساب',
  AutomaticUser: 'مستخدم تلقائي',
  AutomaticMail: 'بريد تلقائي',
  AutomaticNumber: 'رقم تلقائي',
  TypeData: 'نوع البيانات',

  NotificationsManagement: 'إدارة الإشــعارات',
  NotificationStatus: 'حالة الإشعار',
  NotificationIcon: 'أيقونة الإشعار',
  NotificationName: 'اسم الشعار',
  NewNotification: 'إشعـــار جديد',
  EditNotification: 'تعديـل الإشعار',
  NoticNessage1: 'هل أنت متأكد من إيقاف تفعيل هذا الإشعار',
  NoticNessage2: 'هل أنت متأكد من  تفعيل هذا الإشعار',
  ActiveNotification: 'تفعيـل الإشعار',
  TurnOffNotification: 'إيقاف الإشعار',

  TimeSettings: 'إعدادات الوقت',
  SendSettings: 'إعدادات الإرسال',
  Columns: 'الأعمدة',
  Variants: 'المتغيرات',
  NotificationVariables: 'متغيرات الإشعار',
  NotificationInformation: 'معلومات الإشعار',
  Month: 'الشهر',
  Day: 'اليوم',
  Hour: 'الساعة',
  Minute: 'الدقيقة',

  PENDING: 'لم يبت فيه',
  WAITING: 'منتظر للإجراء',
  WAITING_NOTF: 'منتظر للإشعار',
  NOTIFIED: 'تم الإشعار',
  INPROGRESS: 'قيد الإنتظار',
  Delegated: 'مفوض',

  Jobs: 'الوظائف',
  Locations: 'المواقع',
  Jobgrades: 'الدرجات الوظيفية',
  Positions: 'المناصب',
  Staffgroup: 'مجموعة الموظفين',
  AddNewJob: 'إضافة وظيفة جديدة',
  AddJob: 'إضافة وظيفة',
  AddNewJobDegree: 'إضافة درجة وظيفية جديدة',

  Longitude: 'خط الطول',
  Latitude: 'خط العرض',

  EditPosition: 'تعديل منصب',
  AddNewStaffGroup: 'إضافة مجموعة موظفين جديدة',
  AddStaffGroup: 'إضافة مجموعة موظفين',
  EditStaffGroup: 'تعديل مجموعة موظفين',
  AddLocation: 'إضافة موقع',
  EditLocation: 'تعديل موقع',

  DataHasBeenUpdated: 'تم تحديث بيانات',
  FailedDataUpdate: 'فشل تحديث بيانات ',
  ExportData: 'تصدير البيانات',
  ExtraHours: 'ساعات إضافية',
  AttendanceSummary: 'ملخص الحضـور',
  RotationPlanRaqeeb: 'خطة الحضور',

  RotationPlan: 'خطة الحضور',
  ViewSchedulingDays: 'عرض جدولة الأيام',
  AddRotationPlan: 'إضـافة خطة جديدة',
  AttendanceAnalysis: 'تحليل الحضور',
  NumberOfFingerprints: 'عدد البصمات',
  AllowIn: 'بداية التفعيل',
  AllowOut: 'نهاية التفعيل',
  PlanSettings: 'إعدادات الخطة',
  RotationPlanSettings: 'إعدادات خطة الحضور',

  Saturday: 'السبت',
  Sunday: 'الأحد',
  Monday: 'الأثنين',
  Tuesday: 'الثلاثاء',
  Wednesday: 'الأربعاء',
  Thursday: 'الخميس',
  Friday: 'الجمعة',

  OneFingerprint: 'البصمة الأولى',
  TowFingerprint: 'البصمة الثانية',
  ThreeFingerprint: 'البصمة الثالثة',
  FourFingerprint: 'البصمة الرابعة',

  ExtraDay: 'يوم إضافي',
  StatusOfPermanence: 'حالة الدوام',

  navigation: 'التنقل',
  dashboard: 'لوحة القيادة',
  selfService: 'الخدمة الذاتية',
  employees: 'الموظفين',
  employee: 'موظف',
  EmployeeName: 'اسم الموظف',
  Employee: 'الموظف',
  Organizations: 'الإدارات',
  Organization: 'الإدارة',
  OperationUnit: 'وحدة التشغيــل',
  OperationUnits: 'وحدات التشغيــل',
  List_Organizations: ' قائمة الإدارات',
  OrganizationalUnits: 'الوحدات التنظيمية',
  NewOrganizationalUnit: 'وحدة تنظيمية جديدة',

  payroll: 'الرواتب',
  hrSettings: 'إعدادات الموارد البشرية',
  attendancePlan: 'خطة الحضور ( رقيب )',
  systemManagement: 'إدارة النظام',
  approvals: 'إدارة الموافقات',
  users: 'المستخدمين',
  ResetPassword: 'إعادة تعيين كلمة المرور',

  sessionStatus: 'حالة الجلسة',
  expiresIn: 'تنتهي خلال',
  sessionExpired: 'انتهت صلاحية الجلسة',
  sessionExpiredCountdown: 'انتهت صلاحية الجلسة<br>({{countdown}} ثانية)',
  sessionExpiredMessage: 'لقد انتهت صلاحية جلستك. هل ترغب في تجديد بيانات الدخول أو تسجيل الخروج؟',
  refreshLogin: 'تجديد بيانات الدخول',
  logOut: 'تسجيل الخروج',
  success: 'تم بنجاح!',
  loginRefreshSuccess: 'تم تجديد بيانات الدخول بنجاح. يمكنك متابعة استخدام النظام.',
  errorOccurred: 'عذرًا، حدث خطأ',
  loginRefreshError: 'تعذر تجديد بيانات الدخول. سيتم تسجيل خروجك تلقائيًا لضمان الأمان.',
  refreshingLogin: 'جارٍ تجديد بيانات الدخول...',
  pleaseWait: 'يرجى الانتظار لحظات.',

  UserName: 'اسم المستخدم',
  Password: 'كلمة المرور',
  SignIn: 'تسجيل الدخول',
  Responsibilities: 'المسئوليات',
  AddUser: 'إضافة مستخدم',
  UserManagement: 'إدارة المستخدميـن',
  PayrollManagement: 'إدارة الرواتب',
  PayrollsSettings: 'إعدادات الرواتب',
  OnlyEnglishLettersAreAllowed: 'يجب إدخال أحرف إنجليزية فقط',
  OnlyEnglishLettersAndSomeSymbolsAreAllowed: 'يُسمح فقط بالأحرف الإنجليزية وبعض الرموز',

  UserRules: 'صلاحيات المستخدم',
  AddUserRules: 'إضافة صلاحية',
  EditUserRules: 'تعديل صلاحية',

  Permissions: 'الأذونات',
  ApplicationPermissions: 'أذونات التطبيق',
  ExtraPermissions: 'أذونات إضافية',
  RulesPermissions: 'الصلاحيات',

  MobileNumber: 'رقم الجوال',
  Email: 'البريد الإلكتروني',
  Fax: 'فاكس',
  Phone: 'الهاتف',
  TypeOfUser: 'نوع المستخدم',
  UsernameAlreadyExists: 'اسم المستخدم موجود مسبقًا',
  UserEdit: 'تعديل مستخدم',
  'User validity': 'صلاحية المستخدم',
  'User Responsibility': 'مسئولية المستخدم',
  Responsibility: 'المسئولية',
  'Edit Responsibility': 'المسئولية',
  'Add Responsibility': 'إضافة مسئولية',

  RequestsSettings: 'إعدادات الطلبات',
  Conditions: 'الشروط',
  Condition: 'الشرط',
  ConditionDescription: 'وصف الشرط',
  Rules: 'القواعد',
  Field: 'الحقل',
  FieldType: 'نوع الحقل',
  DefaultValue: 'القيمة الإفتراضية',
  Value: 'القيمة',
  TheFirstVariable: 'المتغير الأول',
  TheSecondVariable: 'المتغير الثاني',

  From: 'من',
  To: 'إلى',

  GroupMembers: 'أعضاء المجموعة',
  AddGroupMembers: 'اضافة أعضاء المجموعة',
  Member: 'العضو',
  Order: 'الترتيب',

  DaysAbsence: 'أيام الغياب',
  DetailsOfAbsence: 'تفاصيل الغياب',
  Authorising_Person: 'صاحب الصلاحية ',
  Absence: 'الغياب',
  Absence_Type: 'نوع الغياب',
  Date_TO: 'إلى تاريخ',
  Days: 'الأيام',
  replacement: 'البديل',
  Notes: 'ملاحظات',
  'Leave Request': 'طلب إجازة',
  TypeOfRequest: 'نوع الطلب',
  DateOfRequest: 'تاريخ الطلب',
  NumberOfRequest: 'رقم الطلب',
  RequestDetails: 'تفاصيل الطلب',
  RequestAction: 'إجـراء الطلب',
  Date: 'التاريخ',
  NewRequest: 'طلب جديد',
  SelfServiceRequests: 'طلبات الخدمة الذاتية',
  Procedure: 'الإجـراء',
  Comments: 'التعليقات',

  Request: 'الطلب',
  Applicant: 'مقدم الطلب',
  RequestStatus: 'حالة الطلب',
  RequestsInProgress: 'الطلبات تحت الإجراء',

  Extra_Responsibilities: 'صلاحيات إضافيـة',
  All: 'الكل',
  Partial: 'جزئي',
  _Quick: 'فردي',

  ExtraRecord: 'السجلات الإضافية',
  extrarecord: 'سجلات إضــافيـة',
  AddExtraRecordForm: ' اضافة نماذج السجلات الإضافية',
  ExtraRecordForm: 'نماذج السجلات الإضافية',
  DataTypesForms: 'نماذج أنواع البيانات',
  AddExtraInfoForm: 'إضافة نماذج البيانات الإضافية',
  ExtraInfoForm: 'نماذج البيانات الإضافية',
  ExtraInformation: 'معلومات إضافية',

  ViewReport: 'عرض التقرير',
  Reports_Management: 'إدارة التقارير',
  Reports: 'التقارير',
  ThereAreNoReportsToDisplay: 'لا توجد تقارير لعرضها',
  Report: 'التقرير',
  Reports_Name: 'اسم التقرير',
  Add_Reports: 'إضافة تقرير',
  Edit_Reports: 'تعديل تقرير',
  Report_information: 'معلومات التقرير',
  Report_variants: 'متغيرات التقرير',
  Report_columns: 'أعمدة التقرير',
  Static_Value: 'قيمة ثابتة',
  Parameter_Name: 'اسم المتغير',
  Parameter_Value: 'قيمة المتغير',
  Vasible: 'مرئي',
  Application: 'التطبيق',
  Layout: 'تخطيط ورقة التقرير',
  Parameter_Type: 'نوع المتغير',
  Data_Source: 'مصدر البيانات',
  Alias_Name: 'الأسم المستعار',
  Column: 'العمود',
  NoData: 'لا توجد بيانات لعرضها',

  Function: 'الدالة',
  Add_Chart_For_Report: 'إضافة مؤشر التقريـر',
  Edit_Chart_For_Report: 'تعديل مؤشر التقريـر',
  Charts_Report: 'مؤشرات التقريـر',
  Current_Charts: 'المؤشرات الحالية',
  Indicators: 'المؤشرات',
  Shape: 'الشكل',
  Format_Date: 'صيغة التاريخ',
  Kpi_Name: 'اسم المؤشر',
  DashboardManagement: 'إدارة لوحة المعلومات',
  AddNewDashboard: 'إضـافة لوحة معلومات',
  EditDashboard: 'تعديل لوحة معلومات',
  ManagingPrintingTemplates: 'إدارة قوالب الطباعة',
  PrintingTemplates: 'قوالب الطباعة',
  AddNewTemplates: 'إضافة قالب جديد',
  EditTemplates: 'تعديل قالب الطباعة',
  TemplateSettings: 'إعدادات القالب',
  TemplateName: 'إسـم القالب',
  TemplateType: 'نوع القالب',
  ReportTemplate: 'قالب التقرير',
  TemplateInformation: 'معلومات القالب',
  TemplateVariants: 'متغيرات القالب',
  TemplateColumns: 'أعمدة القالب',
  LetterManagement: 'إدارة الخطابات',
  AddNewLetter: 'إضـافة خطاب',
  'Add&EditLetterTemplate': 'إضافة وتعديل قالب الخطابات',
  TemplateConstructionExplanations: 'توضيحات بناء القالب',
  field: 'حقل',
  FieldName: 'اسم الحقل',
  QR: 'رمز الاستجابة السريعة QR',
  RepetitionLinesInTable: 'تكرار الأسطر في الجدول',
  Height: 'الإرتفاع',
  Width: 'العرض',

  Contracts: 'العقود',
  RealEstateContracts: 'عقود الوحدات العقارية',
  Add_Contract: 'إضافة عقد',
  Edit_Contract: 'تعديل عقد',
  RealEstate: 'الوحدات العقارية',
  Update_Real_Estate: 'تعديل الوحدات العقارية',
  Add_Real_Estate: 'إضافة وحدة عقارية',
  Distance: 'المسافة',
  Accomodation: 'التسكين',

  Type_Real_Estate: 'نوع الوحدة العقارية',
  Types_Real_Estate: 'أنواع الوحدات العقارية',
  Annual_Rent: 'الإيجار السنوي',
  Water_Meter: 'عداد المياه',
  Gas_Counter: 'عداد الغاز',
  Electricity_Meter: 'عداد الكهرباء',
  Attitudes_Meter: 'المواقف بالمتر',
  LandArea: 'المساحة',
  Capacity: 'السـعة',
  Active: 'تفعيل',
  isActive: 'نشط',
  InActive: 'غير نشط',
  NotAvailable: 'غير متوفر',

  InstallmentValue: 'قيمة القسط',
  VAT_Percentage: 'نسبة الضريبة',
  VAT_Value: 'قيمة الضريبة',
  TypeInstallment: 'نوع القسط',
  AddInstallment: 'إضافة قسط',
  InstallmentsGeneration: 'توليد الأقساط',

  BasicData: 'البيانت الأساسية',
  ContractNumber: 'رقم العقد',
  ContractDate: 'تاريخ العقد',
  ContractStatus: 'حالة العقد',
  ContractTerm: 'مدة العقد',
  ContractStartDate: 'تاريخ بداية العقد',
  ContractEndDate: 'تاريخ نهاية العقد',

  FinancialData: 'البيانات المالية',
  AmountRent: 'مبلغ الإيجار',
  AmountVat: 'مبلغ الضريبة',
  PayEvery: 'الدفع كل',
  CountInstallments: 'عدد الأقساط',
  AmountInstallment: 'قيمة القسط',
  Automatic_Renewal: 'تجديد تلقائي',

  Services: 'الخدمات',

  AddBranche: 'إضافة فرع',
  EditBranche: 'تعديل فرع',

  Workshops: 'الورش',
  AddWorkshop: 'إضافة ورشة',
  EditWorkshop: 'تعديل ورشة',

  PaymentDate: 'تاربخ الدفع',
  BankReference: 'مرجع البنك',
  ExchangeRate: 'معدل التحويل',

  Time: 'الوقت',
  EndTime: 'نهاية الوقت',
  StartTime: 'بداية الوقت',
  Maintenance: 'الصيانة',
  RequestTitle: 'عنوان الطلب',
  MaintenanceRequests: 'طلبات الصيانة',
  MaintenanceOrders: 'أوامر الصيانة',
  Settings: 'الإعدادات',
  LastMaintenanceDate: 'تاريخ اخر صيانة',
  Purchase_Price: 'سعر الشراء',
  dateOfExpiry: 'تاريخ الانتهاء',
  ServiceDate: 'تاريخ الخدمة',
  Barcode: 'الباركود',
  Code: 'الكود',
  AssetNumber: 'رقم الأصل',
  Engine_Status: 'حالة المحرك',
  Chassis_Number: 'رقم الشاسيه',
  Serial_Number: 'الرقم التسلسلي',
  Plate_Number: 'رقم اللوحة',
  Assets_and_Equipment: 'الأصول والمعدات',
  AddEquipment: 'إضافة معدات',
  AddVehicle: 'إضـافة مركبة',
  Image_of_Equipment: 'صورة المعدات',
  Odometer: 'عداد المسافات',
  AssignDriver: 'تعيين السائق',
  Update_Odometer: 'تعديل عداد المسافات',
  Drivers: 'السائقين',
  EquipmentAndVehicles: 'المعدات والمركبات',
  HandOver_TakeOver: 'تسليم / إستلام',
  takeoverForm: 'نموذج الإستلام',
  handoverDetails: 'تفاصيل التسليم',
  Vehicles: 'المركبات',
  Handover: 'تسليم',
  Takeover: 'إستلام',
  MaintenanceTeam: 'فريق الصيانة',
  SpareParts: 'قطع الغيار',
  noTeamMembers: 'لا يوجد أعضاء في فريق الصيانة',
  noPartsAdded: 'لا توجد قطع غيار مضافة',

  DriverType: 'نوع السائق',
  EmployeeDriver: 'سائق موظف',
  ExternalDriver: 'سائق خارجي',
  EmployeeNameDisplay: 'اسم الموظف',

  itemName: 'اسم الصنف',
  unit: 'الوحدة',
  quantity: 'الكمية',
  price: 'السعر',
  total: 'الإجمالي',
  description: 'الوصف',
  select: 'اختر',

  DragFilesHere: 'اسحب الملفات هنا أو',
  ChooseFiles: 'أختر ملفات',

  Driver: 'السائق',
  driver: 'سائق',
  Suppliers: 'الموردين',
  Supplier: 'المورد',
  AddDrivers: 'إضافة سائق',
  EditDrivers: 'تعديل سائق',
  AddSuppliers: 'إضافة مورد',
  supplier: 'مورد',
  EditSuppliers: 'تعديل مورد',
  DriverName: 'اسم السائق',
  Owners: 'المُلاك',
  Owner: 'المالك',
  AddOwners: 'إضافة مالك',
  EditOwners: 'تعديل مالك',
  Manufacturers: 'الشركات المصنعة',
  Manufacturer: 'الشركة المصنعة',
  AddManufacturers: 'إضافة شركة مصنعة',
  EditManufacturers: 'تعديل شركة مصنعة',
  Model: 'الطراز',
  AddModel: 'إضافة طراز',
  EditModel: 'تعديل طراز',
  WorkRequests: 'طلب صيانة',
  AddWorkRequests: 'اضافة طلب صيانة',
  DateOfReading: 'تاريخ القراءة',
  OrderNumber: 'رقم الأمر',

  SAR: 'ريال',
  WorkshopNotLinked: 'الورشة المحددة غير مرتبطة بمخزن، لا يمكن إضافة قطع الغيار',
  OrderTypeSelection: 'تحديد نوع أمر الصيانة والجهة المنفذة',
  OrderTypeDescription: 'يرجى تحديد ما إذا كان أمر الصيانة داخلي أو خارجي واختيار الورشة/المورد المناسب',
  OrderType: 'نوع الأمر',
  ConfirmSelection: 'إختيار',

  Journeys: 'الرحلات',

  Equipment: 'المعدات',
  EquipmentName: 'اسم المعدة',
  Residential: 'سكني',
  BusinessLocation: 'موقع العمل',
  BookingSeats: 'حجز المقاعد',
  TypeMaintenance: 'نوع الصيانة',

  InspectionTypes: 'أنواع الفحص',
  InspectionItemsReceiveAndDelivery: 'بنود الفحص (استلام وتسليم)',

  InspectionItems: 'بنود الفحص',
  AddInspectionItems: ' إضافة بنود الفحص',
  EditInspectionItems: ' تعديل بنود الفحص',
  EquipmentInspection: 'فحص المعدات',
  EditInspection: 'تعديل الفحص',
  InspectionLevel: 'مستوى الفحص',
  PreviousInspections: 'الفحوصات السابقة',
  NewScan: 'فحص جديد',
  InspectionDate: 'تاريخ الفحص',
  Item: 'البند',
  AlltemsRequired: 'جميع البنود مطلوبة',

  VehicleInfo: 'معلومات المركبة',
  Vehicle: 'المركبة',
  DeliveryDate: 'تاريخ التسليــم',
  ReceiptDate: 'تاريخ الإستلام',
  HandoverDate: 'تاريخ التسليم',
  TakeoverDate: 'تاريخ الإستلام',

  statusAndEndDate: 'حالة الأمر وتاريخ الإغلاق',
  NewMaintenanceOrder: 'أمر صيانة جديد',
  DirectMaintenanceOrder: 'أمر صيانة مباشر',
  MaintenanceOrderFromRequest: 'أمر صيانة من طلب صيانة',
  inventoryStatus: 'حالة المخزن',
  isConfrimStatus: 'حالة التأكيد',
  Open: 'مفتوح',
  Closed: 'مغلق',

  InspectionList: 'قائمة الفحص',
  VehicleDiagram: 'الرسم التخطيطي للمركـبة',
  Attachments: 'المرفقـات',
  AddYourNotesHere: 'أضف ملاحظاتك هنا',
  Saving: 'جاري الحفظ',

  VehicleLogs: 'سجل المركـبة',
  Mode: 'الوضع',
  Draw: 'رسم',
  Comment: 'تعليق',
  DrawingMode: 'وضع الرسم',
  CommentingMode: 'وضع التعليق',
  MarkerType: 'نوع العلامة',
  Circle: 'دائرة',
  Square: 'مربع',
  Line: 'خط',
  Ring: 'حلقة',
  MarkerColor: 'لون العلامة',
  Red: 'أحمر',
  Blue: 'أزرق',
  Green: 'أخضر',
  Yellow: 'أصفر',
  Purple: 'بنفسجي',
  MarkerSize: 'حجم العلامة',
  CommentLabel: 'التعليــق',
  ShowPredefinedComments: 'عرض التعليقات الجاهزة',
  PredefinedComments: 'تعليقات جاهزة',
  DeleteMarker: 'حذف العلامة',
  DamageDescriptionPlaceholder: 'أدخل وصفًا للضرر...',
  Undo: 'تراجــع',
  ClearAll: 'مسح الكل',
  SaveSuccessMessage: 'تم حفظ أماكن المشاكل والتعليقات بنجاح!',
  ClearConfirmation: 'هل أنت متأكد من مسح جميع العلامات؟',
  DrawingInstruction: 'انقر على الصورة لإضافة علامة في مكان الضرر',
  CommentingInstruction: 'انقر على علامة موجودة لإضافة تعليق',
  ShowMore: 'عرض المزيد',
  HideHelp: 'إخفاء المساعدة',
  HelpDrawInstruction: 'في وضع الرسم: انقر لإضافة علامة',
  HelpCommentInstruction: 'في وضع التعليق: انقر على علامة لتحديدها',
  HelpDragInstruction: 'اسحب العلامات لتعديل موقعها',
  Scratch: 'خدش',
  Dent: 'انبعاج',
  Break: 'كسر',
  Rust: 'صدأ',
  Corrosion: 'تآكل',
  Crack: 'تشقق',
  ColorDamage: 'تلف اللون',

  DescriptionAR: 'ملاحظات عربي',
  DescriptionEN: 'ملاحظات انجليزي',
  Descriptions: 'ملاحظات',

  Workshop: 'الورشة',
  Expected_start_date: 'تاريخ البدء المتوقع',
  Expected_end_date: 'تاريخ الانتهاء المتوقع',
  Material_price: 'سعر المواد',
  Remuneration_Workers: 'أجور العمال',
  Other_amounts: 'مبالغ اخرى',
  Total: 'الإجـمالي',
  RequestNumber: 'رقم الطلب',
  RequestDescription: 'وصف الطلب',
  RequestType: 'نوع الطلب',
  RequestDate: '  تاريخ الطلب',
  Priority: 'الأولوية',
  Source: 'المصدر',
  Branch: 'الفرع',
  Description: 'الوصف',
  Attachment: 'المرفق',
  Flexible: 'مرن',

  Close_Maintenance_Order: 'إغلاق أمر الصيانة',
  MaintenanceOrder: 'أمر صيانة',
  CreateMaintenanceOrder: 'إنشـاء أمر صيـانة',
  AddMaintenanceOrder: 'إضافة أمر صيانة',
  DateCompletion: 'تاريخ الإغلاق',
  actual_implementation_start_date: 'تاريخ بدء التنفيذ الفعلي',
  actual_implementation_end_date: 'تاريخ انتهاء التنفيذ الفعلي',
  Expected_total: 'الإجمالي المتوقع',
  UpdateWorkOrder: 'تعديل أمر الصيانة',

  OrderAlreadyClosed: 'أمر الصيانة مغلق بالفعل',
  OrderClosedOnDate: 'تم إغلاق أمر الصيانة في تاريخ',

  MaterialsIssued: 'تم صرف المواد',
  MaterialsNotIssued: 'لم تصرف المواد',
  MaterialsNotIssued_: 'المواد لم تصرف من المخزن',
  MaterialsNotIssuedMessage:
    'يجب صرف جميع المواد من المخزن قبل إغلاق أمر الصيانة. الرجاء التوجه إلى قسم المخزن لإكمال عملية الصرف.',
  CannotCloseUntilMaterialsIssued: 'لا يمكن الإغلاق حتى تصرف المواد',
  Confirmed: 'تم التأكيد',
  NotConfirmed: 'غير مؤكد',
  ConfirmWorkOrder: 'تأكيد أمر الصيانة',
  WorkOrderConfirmedSuccessfully: 'تم تأكيد أمر الصيانة بنجاح',
  MaintenanceOrderDetails: 'تفاصيل أمر الصيانة',
  CLosingDetails: 'تفاصيل الإغلاق',
  NoNotesAvailable: 'لا توجد ملاحظات',
  AddCompletionNotes: 'إضافة ملاحظات الإكمال',
  Processing: 'جاري المعالجة',
  AreYouSureConfirmWorkOrder: 'هل أنت متأكد من تأكيد أمر الصيانة؟',
  WorkOrderConfirmationNote: 'بعد التأكيد، لا يمكن التراجع عن هذا الإجراء',
  ConfirmationFailed: 'فشل التأكيد',
  orderConfirmedNoEdit: 'تم تأكيد الأمر ولا يمكن التعديل عليه',

  Horsepower: 'القوة بالحصان',
  Horsepower_Tax: 'ضريبة القدرة الحصانية',
  Number_of_Doors: 'عدد الأبواب',
  Number_of_Seats: 'عدد المقاعد',
  Barcodes: 'الباركود',
  Type_of_Fuel: 'نوع الوقود',
  State_of_Manufacture: 'دولة الصنع',
  Year_of_Manufacture: 'سنة الصنع',
  Transmission: 'ناقل الحركة',

  OurTeam: 'فريق العمل',
  MyHolidays: 'إجازاتي',
  MyRequests: 'طلباتي',
  Requests: 'الطلبات',
  ViewRequestDetails: 'عرض تفاصيل الطلب',
  ViewRequest: 'عرض الطلب',
  ViewRequests: 'عرض الطلبات',
  SendRequest: 'إرسال الطلب',
  Send: 'إرسال',

  MyInformation: 'معلوماتي',
  NOTIFICATIONS: 'الإشعارات',

  UploadFile: 'تحميل ملف',
  You_will_have_a_chance_to_rename_or_remove_columns_in_next_steps:
    'سيكون لديك فرصة لإعادة تسمية الأعمدة أو إزالتها في الخطوات التالية',
  SelectFile: 'إختر ملف',
  Select_header_row: 'إختيار رأس الجدول',
  Match_Columns: 'مطابقة الأعمدة',
  Your_table: 'الجدول الخاص بك',
  Will_become: 'سوف يصبح',
  Match: 'مطابقة',
  UnMatched: 'غير مطابق',
  Columns_cannot_duplicate: 'لا يمكن تكرار الأعمدة',
  Validate_data: 'التحقق من صحة البيانات',
  Show_only_rows_with_errors: 'إظهار الصفوف التي بها أخطاء فقط',
  Discord_selected_rows: 'تجاهل الصفوف المحددة',
  Confirm: 'تأكيد',
  Data_that_we_expect: 'البيانات التي نتوقعها',
  Columns_not_matched: 'الأعمدة الغير متطابقة',
  There_are_required_columns_that_are_not_matched_or_ignored_Do_you_want_to_continue:
    'هناك أعمدة مطلوبة غير متطابقة أو متجاهلة. هل تريد الاستمرار',
  Not_all_columns_matched: 'ليست كل الأعمدة متطابقة',
  Continue: 'إستمرار',
  SelectAll: 'تحديد الكل',
  UnSelectAll: 'إلغاء تحديد الكل',

  Exit_import_flow: 'الخروج من عملية الاستيراد',
  Are_you_sure_Your_current_information_will_not_be_saved: 'هل أنت متأكد? لن يتم حفظ المعلومات الحالية الخاصة بك.',

  GeneralSystem: 'النظام العام',
  HumanResources: 'إدارة شؤون الموظفيــن',
  ApprovalsManagement: 'إدارة الموافقات',
  SupportingUnits: 'الخدمات المساندة',
  Propertymanagement: 'إدارة الأملاك',
  FinancialSystem: 'النظام المالي',
  IntegrationWithSystems: 'التكامل مع الأنظمة',
  FleetManagement: 'إدارة الاسطول',

  TemporarySave: 'حفظ مؤقت',
  Debt: 'مدين',
  Debit: 'مدين',
  Credit: 'دائن',
  CostCenter: 'مركز التكلفة',
  Accounts: 'الحسـاب',
  Company: 'الشركة',
  Category: 'التصنيف',
  AccountingPeriod: 'الفترة المحاسبية',

  Operations: 'العمليات',
  PaymentInvoices: 'فواتير المدفوعات',
  PostPaymentInvoices: 'ترحيل فواتير المدفوعات',
  PaymentVouchers: 'سندات الدفع',
  PostPaymentVouchers: 'ترحيل سندات الدفع',
  Expenses: 'المصروفات',
  InvoicePayments: 'سداد الفواتير',
  PaymentTerms: 'شروط الدفع',
  Currencies: 'العملات',
  TypesOfExpenses: 'أنواع المصروفات',

  SupplierName: 'اسم المورد',
  SupplierNumber: 'رقم المورد',
  TradingName: 'الأسم التجاري',
  SupplierDetails: 'تفاصيـل المورد',
  ContactInformation: 'بيانات التواصل',
  ContactInformationForSupplier: 'بيانات التواصل للمورد',
  AddNewSupplier: 'إضافة مورد جديد',

  Display: 'عرض',
  Records: 'سجلات',
  SearchPlaceholder: 'ابحث هنا.',

  SupplierType: 'نوع المورد',

  CompanyRegistrationNumber: 'رقم تسجيل الشركة',
  NationalInsuranceNumber: 'رقم الضمان الوطني',

  InvoiceCurrency: 'عملة الفاتورة',
  PaymentCurrency: 'عملة الدفع',
  InvoiceLimit: 'حد مبلغ الفاتورة',
  CreditLimit: 'الحد الائتماني',
  BankAccountName: 'اسم الحساب البنكي',
  BankAccountNumber: 'رقم الحساب البنكي',
  BankNumber: 'رقم البنك',
  BankAccountType: 'نوع الحساب البنكي',
  Account: 'الحساب',
  PrepaymentAccount: 'حساب الدفعات المقدمة',
  SetOfBooks: 'دفتر الحسابات',
  VATCode: 'الرقم الضريبي',
  VerificationNumber: 'رقم التحقق',
  WorkReference: 'اسم الشخص',
  ShipToLocation: 'موقع الشحن',
  BillToLocation: 'موقع الفوترة',
  PaymentPriority: 'أولوية الدفع',

  PersonalAndContactInformation: 'المعلومات الشخصية والاتصال',
  FinancialAndBankingInformation: 'المعلومات المالية والمصرفية',
  InstitutionalLegalIdentity: 'الهوية المؤسسية/القانونية',
  LocationAndPayment: 'الموقع والدفع',

  AddBranchForSupplier: 'إضافة فرع للمورد',

  SupplierBranches: 'فروع المورد',
  WebsiteLink: 'رابط الموقع الإلكتروني',

  ExpenseTypes: 'أنواع المصروفات',
  CategoryName: 'اسم التصنيف',
  SourceName: 'اسم المصدر',
  CategoryItems: 'عناصر التصنيف',
  ExpenseCategoryItems: 'عناصر فئة المصروفات',

  AddPaymentTerm: 'إضافة شرط جديد',
  Period: 'الفترة',
  PaymentTerm: 'شرط الدفع',

  AddCurrency: 'إضافة عملة جديدة',
  State: 'الحالة',

  CurrencyName: 'اسم العملة',
  CurrencyCode: 'كود العملة',

  NewInvoice: 'فاتورة جديدة',
  Details: 'التفاصيل',
  InvoiceNumber: 'رقم الفاتورة',
  InvoiceDate: 'تاريخ الفاتورة',
  InvoiceType: 'نوع الفاتورة',
  Amount: 'المبلغ',
  PostingStatus: 'حالة الترحيل',
  Posted: 'مُرحلة',
  NotPosted: 'غير مُرحلة',
  AddNewInvoice: 'إضافة فاتورة جديدة',

  SupplierInvoiceNumber: 'رقم فاتورة المورد',

  CurrencyConversionRate: 'معدل تحويل العملة',

  InvoiceLines: 'بنود الفاتورة',
  InvoiceSchedule: 'جدولة الفاتورة',
  Standard: 'قياسي',
  DebitMemo: 'إشعار مدين',
  CreditMemo: 'إشعار دائن',
  Prepayment: 'الدفع المسبق',
  Prepayments: 'دفعات مقدمة',
  Reminder: 'تذكير',

  Warning: 'تنبيه',
  PrepaymentMessage: 'هذا المورد لديه دفعات مقدمة بإجمالي:',
  InvoiceLinesRequired: 'بنود الفاتورة مطلوب',
  InvoiceScheduleRequired: 'جدولة الفاتورة مطلوب',

  InvoiceDetails: 'تفاصيـل الفاتورة',
  AddNewLine: 'إضافة بند جديد',
  Quantity: 'الكمية',
  Price: 'السعر',
  DiscountRate: 'نسبة الخصم',
  DiscountAmount: 'قيمة الخصم',
  VAT: 'الضريبة',
  'VAT %': 'نسبة الضريبة',
  AccountDetails: 'تفاصيل الحساب',
  AddNewItem: 'إضافة صنف جديد',
  'Include VAT': 'متضمن الضريبة',
  'Exclude VAT': 'غير متضمن الضريبة',

  PostSelectedInvoices: 'ترحيل الفواتير المختارة',
  GeneralLedger: 'الإستاذ العام',

  Post: 'ترحيـل',

  InvalidDateInPeriod: 'التاريـخ ليس ضمن الفترة المحاسبية',
  PostSuccessMessage: 'تم الترحيـــل بنجاح',

  VoucherNumber: 'رقم السند',

  PaymentType: 'نوع السند',

  PostedFlag: 'حالة الترحيل',

  Payments: 'سندات الدفع',
  NewPayment: 'سنـد جديـد',

  PaymentNumber: 'رقم الدفعة',

  InvoiceAmount: 'مبلغ الفاتورة',
  RemainingAmount: 'المبلغ المتبقي',
  DueDate: 'تاريخ الاستحقاق',

  FetchInvoices: 'جلب الفواتير',
  Submit: 'موافق',
  Ok: 'موافق',
  PaySelectedInvoices: 'تسديد الفواتير المحددة',
  PrePayment: 'دفعة مقدمة',
  PrePaymentTotal: 'إجمالي الدفع المسبق',

  'Payment Method': 'طريقة الدفع',
  'Bank / Fund': 'البنك / الصندوق',
  Banks: 'البنوك',
  NewBank: 'بنك جديد',
  EditBank: 'تعديل بنك',
  AddBank: 'اضافة بنك',

  PrePaymentAmount: 'مبلغ الدفعة المقدمة',
  AddNewPaymentVoucher: 'إضافة سند جديـد',

  Pay: 'دفع',

  InvoiceTotal: 'إجمالي الفاتورة',

  PaymentAmount: 'قيمة الدفعة',
  Delete: 'حذف',

  AmountToPay: 'القيمة المراد تسديدها',
  Error: 'خطأ',

  ManagePayments: 'إدارة المدفوعات',

  VoucherType: 'نوع السند',

  PostedStatus: 'حالة الترحيل',
  PostSelectedVouchers: 'ترحيــل السندات المحددة',

  ExpenseCategory: 'فئة المصروف',
  ExpenseDate: 'تاريخ المصروف',
  TotalAmount: 'إجمالي المبلغ',

  welcome: 'مرحبـا بكم',
  neatix: 'الحل المتقن',
  hr: 'إدارة شؤون الموظفين',
  payrollManagement: 'إدارة الرواتب',
  attendanceManagement: 'إدارة الحضور',
  approvalsManagement: 'إدارة الموافقات',
  financeManagement: 'الإدارة المالية',
  payablesManagement: 'إدارة المدفوعات',
  receivablesManagement: 'إدارة المستحقات',
  inventoryManagement: 'إدارة المخزون',
  purchaseManagement: 'إدارة المشتريات',
  salesManagement: 'إدارة المبيعات',
  posManagement: 'إدارة نقاط البيع',
  reportsManagement: 'إدارة التقارير وقوالب الطباعة',
  notificationsSystem: 'إدارة الإشعارات',
  assetsManagement: 'إدارة الأصـول',
  fleetManagement: 'إدارة الأسطول',
  supportingUnits: 'إدارة الوحدات المساندة',
  integrationManagement: 'إدارة التكامل',
  cashManagement: 'إدارة النقدية',

  projectManagement: 'إدارة المشاريع',
  taskManagement: 'إدارة المهام',
  productionManagement: 'إدارة الإنتاج',

  Customers: 'العملاء',
  ReceivablesInvoices: 'فواتيـر الإستحقاق',
  PostReceivablesInvoices: 'ترحيـل فواتير الإستحقاق',
  Receipts: 'سندات الإستلام',
  PostReceipts: 'ترحيــل سندات الإسنلام',

  CustomerName: 'اسم العميل',
  CustomerNumber: 'رقم العميل',
  CustomerDetails: 'تفاصيل العميل',
  CustomerContactInformation: 'معلومات الاتصال للعميل',
  AddNewCustomer: 'إضافة عميل جديد',

  Customer: 'العميل',
  customer: 'عميل',
  ReceivableInvoices: 'فواتير الاستحقاق',

  AddNewTransaction: 'إضافة معاملة جديدة',
  ShippingLocation: 'موقع الشحن',
  BillingLocation: 'موقع الفوترة',
  CustomerInvoiceNumber: 'رقم فاتورة العميل',
  SalesRepresentative: 'مندوب المبيعات',

  ReceiptNumber: 'رقم السند',
  ReceiptType: 'نوع السند',
  NewReceipt: 'سنـد جديـد',

  PrePaymentValue: 'القيمة',
  SettleSelectedInvoices: 'تسديد الفواتير المحددة',
  BatchNumber: 'رقم الدفعة',

  BankAccount: 'البنك / الصندوق',
  Receipt: 'إستلام',
  AddNewReceipt: 'إضافة سند جديد',
  Retry: 'إعادة المحاولة',

  PostSelectedReceipts: 'ترحيــل السندات المحددة',

  Inventory: 'المخزن',
  Inventories: 'المخازن',
  SubInventories: 'المخازن الفرعيـة',
  AddSubInventory: 'اضافة مخزن فرعي',
  NewSubInventory: 'مخزن فرعي جديد',
  AddInventory: 'اضافة مخزن',
  NewInventory: 'مخزن جديد',
  EditInventory: 'تعديل مخزن',
  SubInventory: 'المخازن الفرعية',
  Items: 'الأصناف',

  ManageInventoryItems: 'إدارة أصناف المخزن',
  ItemsNotInInventory: 'أصناف غير موجودة في هذا المخزن',
  AddToInventory: 'إضافة إلى المخزن',
  ItemsInInventory: 'الأصناف الحالية في هذا المخزن',
  RemoveFromInventory: 'إخراج من المخزن',

  Categories: 'الفئـات',
  AddMainCategory: 'اضاف فئة رئيسية',
  AddCategory: 'اضافة فئة',
  ViewProductImages: 'عرض صور المنتج',
  MeasurementUnits: 'وحدات القياس',
  TransactionTypes: 'أنواع الحركات المخزنية',
  NewReason: 'سبب جديد',
  AddReasons: 'إضافة أسباب',
  UpdateReasons: 'تعديل سبب',
  NewAttribute: 'سمة جديدة',
  ItemAttributes: 'سمـات الأصناف',
  AddNewAttribute: 'إضافة سمة جديــدة',
  EditAttribute: 'تعديـل سمة',
  AssignmentAttribute: 'إسناد سمة إلى عناصر متعددة',
  ExtraPrice: 'سعر إضافي',
  Color: 'اللون',

  FillBasicItemDataToAddToInventory: 'املأ البيانات الأساسية للصنف لإضافته إلى المخزون',
  Pricing: 'التسعير',
  EnterLocalName: 'أدخل الاسم المحلي',
  EnterGlobalName: 'أدخل الاسم العالمي',
  EnterBarcode: 'أدخل الباركود',
  ItemCode: 'كود الصنف ',
  EnterItemCode: 'أدخل كود الصنف',
  ItemCategory: 'فئة الصنف',
  ItemType: 'نوع الصنف',
  UnitOfMeasure: 'وحدة القياس',
  DistributionMethod: 'طريقة التوزيع',
  SalesPrice: 'سعر البيع',
  PurchasePrice: 'سعر الشراء',
  UpperDemandLimit: 'حد الطلب الأعلى',
  LowerDemandLimit: 'حد الطلب الأدنى',
  ItemSettings: 'إعدادات الصنف',
  ServiceItem: 'صنف خدمي',
  InventoryItem: 'صنف مخزني',
  TrackInventory: 'تتبع المخزون',
  EnableCustomerOrders: 'تمكين طلبات العملاء',
  AvailableForSale: 'متاح للبيع',
  EnablePurchasing: 'تمكين الشراء',
  InternalTransfer: 'تحويل داخلي',
  AllowNegativeStock: 'السماح بالمخزون السالب',
  BackToBasic: 'العودة للمعلومات الأساسية',
  BackToPricing: 'العودة للتسعير',
  ContinueToPricing: 'المتابعة إلى التسعير',
  ContinueToSettings: 'المتابعة إلى الإعدادات',
  AddItem: 'إضافة الصنف',

  ItemDetails: 'تفاصيل الصنف',
  ItemData: 'بيانات الصنف',
  ItemUnits: 'وحدات الصنف',
  LotNumbers: 'أرقام التشغيل',
  ProductImage: 'صورة المنتج',
  ItemSuppliers: 'موردين الصنف',

  ConversionValue: 'التعادل',
  Unit: 'الوحدة',
  NoUnitsForItem: 'لا يوجد وحدات لهذا الصنف',
  ConfirmDelete: 'هل أنت متأكد من عملية الحذف؟',
  LotNumber: 'رقم التشغيل',
  ExpirationDate: 'تاريخ الإنتهاء',
  Attribute: 'الســمة',
  NoAttributesForItem: 'لا توجد سمات لهذا الصنف',
  SelectAlternativeItems: 'حدد الأصناف البديلة',
  SelectItemSuppliers: 'حدد الموردين لهذا الصنف',
  IssuanceReasons: 'أسباب الصرف',
  AdditionReasons: 'أسباب الإضافة',
  UpdateReason: 'تحديث السبب',
  NewBrand: 'علامة تجارية جديدة',
  EditBrand: 'تعديل علامة تجارية',

  TransactionDate: 'تاريخ الحركة',
  ReferenceNumber: 'رقم المرجع',
  ReferenceType: 'نوع المرجع',
  PurchaseReturn: 'مردود مشتريات',
  TransferOrderIssue: 'صرف أمر تحويل',
  SalesOrder: 'أمر بيع',
  Issue: 'صرف',
  RawMaterialIssue: 'صرف مواد خام',
  FinalProductReceipt: 'استلام منتج نهائي',
  TransferReceipt: 'استلام أمر تحويل',
  Addition: 'إضافة',
  PurchaseOrder: 'أمر شراء',

  // "InvIssue": "صرف مخزني",
  // "AddInvIssue": "إضافة صرف",
  TransferOrder: 'أمر تحويل',
  IssueDocument: 'إذن صــرف',
  AddIssueDocument: 'إضافة إذن صرف',
  // "OperatingUnit": "الوحدة التشغيليـة",
  TransactionType: 'نوع الحركة',
  StoreKeeper: 'أمين المخزن',
  SelectOperatingUnitInventoryTransaction: 'اختيار وحدة التشغيل والمخزن ونوع الحركة',
  PleaseSelectOperatingUnitInventoryTransactionType: 'يرجى اختيار وحدة التشغيـل المخزن، ونوع الحركة لإتمام العملية',
  Select: 'إختيار',

  // "InvIssue": "صرف مخزني",
  UpdateInvIssue: 'تعديل صرف',
  EditIssuePermission: 'تعديل إذن صـرف',
  Reference: 'المرجـع',
  JournalDetails: 'تفاصيـل القيد',

  ItemName: 'اسم الصنف',
  AllLots: 'الكل',
  AvailableQuantity: 'الكمية المتاحة',
  DispensedQuantity: 'الكمية المصروفة',
  FullyProcessed: 'تم معالجة الكمية بالكامل',
  RemainingQuantity: 'الكمية المتبقية',
  ReservedQuantity: 'الكمية المحجوزة',
  InventoryDetails: 'تفاصيل المخـزون',
  None: 'لا يوجد',

  TransferIssue: 'صرف أمر تحويل',

  EditItem: 'تعديل الصـنف',

  Sections: 'الأقسام',
  Units: 'الوحدات',
  ItemWarehouses: 'مخازن الصنف',
  ItemInventory: 'مخازن الصنف',
  // "AlternativeItems": "الأصناف البديلة",
  ItemImage: 'صورة الصنف',

  ReceivePermission: 'إذن إضـافة',
  NewReceivePermission: 'إذن إضـافة جديد',

  EditReceivePermission: 'تعديــل إذن إضافة',
  CannotEditAfterPosting: 'عذراً، لا يمكنك التعديــل بعد الترحيل . نشكرك على تفهمك.',
  RecordPosted: 'تم ترحيل السجل',

  NewLotNumber: '🆕 رقم تشغيل جديد',
  PreviouslyAddedQuantity: 'الكمية المضافة سابقاً',
  AddedQuantity: 'الكمية المضافة',

  SelectSalesInvoice: 'أختر فاتورة المبيعات',
  SelectSalesOrder: 'أختر أمر البيع',
  SelectTransferDocument: 'أختر مستند التحويل',
  SelectTransferOrder: 'أختر أمر التحويـل',
  SelectPurchaseReturn: 'اختر مردود المشتريات',
  SelectPurchaseInvoice: 'اختر فاتورة المشتريات',
  SelectPurchaseOrder: 'اختر أمر الشراء',
  SelectSalesReturn: 'اختر مردود المبيعات',
  SelectTransferReceipt: 'اختر استلام التحويل',
  SelectAdditionReason: 'اختر سبب الإضافة',
  SelectIssueReason: 'اختر سبب الصرف',
  SelectMaintenanceOrder: 'اختر أمر الصيانة',
  SelectReference: 'اختر المرجع',
  LoadingData: 'جاري تحميل البيانات',
  FailedToLoadData: 'فشل تحميل البيانات',

  ErrorLoadingData: 'خطأ في تحميل البيانات',
  Filters: 'الفلاتر',
  DateRange: 'نطاق التاريخ',
  SelectDateRange: 'اختر نطاق التاريخ',
  ResetFilters: 'إعادة تعيين الفلاتر',
  LoadReport: 'تحميل التقرير',
  Loading: 'جاري التحميل...',
  LoadingStockCardData: 'جاري تحميل بيانات كارت الصنف...',
  TransactionCode: 'كود الحركة',
  QuantityIn: 'الكمية الداخلة',
  QuantityOut: 'الكمية الخارجة',
  UnitPrice: 'سعر الوحدة',
  TotalQuantity: 'الكمية الإجمالية',
  NoDataAvailable: 'لا توجد بيانات متاحة. قم بتعيين الفلاتر وانقر على "تحميل التقرير" للإنشاء.',
  ReportGeneratedOn: 'تم إنشاء التقرير في',
  ItemRequired: 'الصنف مطلوب',
  UnknownError: 'حدث خطأ غير معروف',
  OpeningBalance: 'رصيد افتتاحي',

  confirmPostMessage: 'هل أنت متأكد من ترحيل العمليات المحددة؟',
  // "PostSuccessMessage": "تم ترحيل العمليات بنجاح",
  PostErrorMessage: 'حدث خطأ أثناء الترحيل',
  transactionType: 'نوع الحركة',
  transactionCode: 'كود الحركة',
  status: 'الحالة',
  Pending: 'في انتظار المعالجة',
  ProcessingResults: 'نتائج المعالجة',
  Summary: 'ملخص',
  // "Details": "تفاصيل",
  TotalTransactions: 'إجمالي العمليات',
  Successful: 'ناجحة',
  Failed: 'فاشلة',
  code: 'الكود',
  type: 'النوع',
  errorMessage: 'رسالة الخطأ',
  Success: 'نجح',
  SomeTransactionsFailed: 'فشل ترحيل بعض العمليات',
  DownloadErrorReport: 'تحميل تقرير الأخطاء',
  // "Processing": "جاري المعالجة",
  // "Post": "ترحيل",
  // "Cancel": "إلغاء",
  Close: 'إغلاق',
  PostInventory: 'ترحيل العمليات المخزنية ',
  selectedTransactionsCount: 'تم تحديد عدد عملية للترحيل',

  AllOperationsFailed: 'فشلت جميع العمليات',
  operationsSucceeded: 'عملية ناجحة و',
  operationsFailed: 'عملية فاشلة',

  PurchaseRequestNumber: 'رقم الطلب',
  PurchaseRequestDate: 'تاريخ الطلب',

  SendToSuppliers: 'إرسـال للمورديـن',
  AddNewPurchaseRequest: 'طلب شراء جديد',
  PurchaseRequests: 'طلبات الشــراء',

  Purchases: 'المشتريات',
  Quotations: 'عروص الأسعار',
  PurchaseOrders: 'أوامر الشراء',
  PurchaseReturns: 'مردود المشتريات',
  ReceiveNoneInventoryItems: 'إستلام الطلبات الغيــر مخزنية',

  CCSIDOTP: 'OTP الخاص بـ CCSID',
  GetCCSID: 'احصل على CCSID',
  CCSIDBinaryToken: 'الرمز الثنائي لـ CCSID',
  TokenSecret: 'سر الرمز',
  RequestID: 'رقم الطلب',
  GetPCSID: 'احصل على PCSID',
  PCSIDBinaryToken: 'الرمز الثنائي لـ PCSID',
  PCSIDSecret: 'سر PCSID',
  RegisteredDate: 'تاريخ التسجيل',
  CSRInformation: 'معلومات CSR',
  CSRIndustryBusinessCategory: 'فئة النشاط التجاري',
  CSRCommonName: 'الاسم العام',
  CSRSerialNumber: 'الرقم التسلسلي',
  CSROrganizationIdentifier: 'معرّف المؤسسة',
  CSROrganizationUnitName: 'اسم الوحدة التنظيمية',
  CSROrganizationName: 'اسم المؤسسة',
  CSRCountryName: 'اسم الدولة',
  CSRInvoiceType: 'نوع الفاتورة',
  CSRLocationAddress: 'عنوان الموقع',
  CSREnvironmentType: 'نوع البيئة',
  EnvironmentTypePlaceholder: 'إنتاجي أو اختباري',
  GenerateCSR: 'توليد CSR',
  GeneratedCSR: 'CSR المُولَّد',
  GeneratedPrivateKey: 'المفتاح الخاص المُولَّد',
  BusinessInformation: 'معلومات العمل',
  RegistrationName: 'اسم التسجيل',
  RegistrationNamePlaceholder: 'اسم الشركة',
  CompanyID: 'رقم الشركة',
  TaxSchemeID: 'نظام الضرائب',
  BusinessID: 'رقم تعريف النشاط',
  IdentificationScheme: 'نظام التعريف',
  StreetName: 'اسم الشارع',
  CityName: 'اسم المدينة',
  CitySubdivisionName: 'اسم الحي',
  BuildingNumber: 'رقم المبنى',
  PostalZone: 'الرمز البريدي',
  CountryCode: 'رمز الدولة',
  BusinessCategory: 'فئة النشاط التجاري',
  BusinessCategoryPlaceholder: 'نشاط التوريد',
  Applications: 'التطبيـــقات',

  Warehouses: 'المخازن',
  UnitsOfMeasure: 'وحدات القياس',
  Brand: 'العلامة التجارية',
  Attributes: 'الخصائص',
  InvIssue: 'إذن صرف',
  InvReceive: 'إذن إضافة',
  InvMove: 'مستندات التحويل',
  UpdateCost: 'تحديث سعر التكلفة',
  Allocate: 'حجز',
  CreateAccountInventory: 'ترحيل العمليـات المخزنيـة',
  InventoryCount: 'جرد المخزن',
  PhysicalInventory: 'الجرد الفعلي',
  InventoryResults: 'نتائج الجرد',

  TransType: 'نوع الحركة',
  Number: 'الرقم',
  Action: 'إجراء',
  AddInvIssue: 'إذن صرف جديد',
  AddInvReceive: 'إذن اضافة جديـد',

  Sales: 'المبيعات',
  SellOrder: 'أوامر البيع',
  SalesReturn: 'مردود المبيعات',
  PriceList: 'قائمة الأسعار',
  Vouchers: 'القسـائم',

  NewQuotation: 'عرض سعر جديد',

  SendToCustomer: 'إرسال للعميل',

  SalesOrders: 'أوامر البيع',
  NewSalesOrder: 'أمر بيع جديد',
  NewSalesOrderFromQuotation: 'إنشاء أمر بيع من عرض سعر',
  Delivered: 'تم الصرف',
  NotDelivered: 'لم يتم الصرف',

  SalesOrderNumber: 'رقم أمر البيع',
  SalesOrderDate: 'تاريخ أمر البيع',

  Return: 'استرداد',

  Collapse: 'طي',
  Expand: 'توسيع',
  MainList: 'القائمة الرئيسية',
  SubList: 'قائمة فرعية',
  AddPriceList: 'اضافة قائمة أسعار جديدة',
  PriceLists: 'قوائم الأسعار',
  AddNewPriceList: 'قائمة جديدة',
  EditPriceList: 'تعديل قائمة الأسعار',

  PurchaseRequest: 'طلب الشراء',
  QuotationComparison: 'مقارنة عروض الأسعار',

  NewAttendanceRequest: 'إستئذان جديـد',
  AttendanceRequests: 'الإستئذانات',
  AddNewAttendanceRequest: 'إضافة إستئذان جديـد',
  EditNewAttendanceRequest: 'تعديل إستئذان جديـد',
  EditHoliday: 'تعديل إجازة',
  AddNewHoliday: 'إصافة إجازة جديدة',
  NewHoliday: 'إجـازة جديدة',
  Holidays: 'الإجـازات',

  FiscalYear: 'السنة المالية',
  StartDate: 'تاريخ البدء',
  EndDate: 'تاريخ الانتهاء',
  AddFiscalYear: 'اضافة سنة مالية',
  EditFiscalYear: 'تعديل سنة مالية',
  StartOfYear: 'بداية السنة',
  EndOfYear: 'نهاية السنة',
  Start: 'بداية الفترة',
  End: 'نهاية الفترة',
  ClosePeriod: 'إغلاق الفتـرة',
  CloseAccountingPeriod: 'إغلاق الفترة المحاسبية',
  AccountingPeriods: 'الفترات المحاسبية',
  AddAccountingPeriod: 'إضافة فترة محاسبية',
  EditAccountingPeriod: 'تعديل فترة محاسبية',

  AddGeneralLedger: 'إضافة أستاذ عام',
  EditGeneralLedger: 'تعديل الأستاذ العام',
  ChartOfAccounts: 'شجرة الحسابات',

  FromDate: 'من تاريخ',
  ToDate: 'إلى تاريخ',
  Rate: 'المعدل',
  New: 'جديد',
  DailyRates: 'المعدل اليومي للعملات',

  JeSource: 'مصادر القيود',
  AddJeSource: 'إضافة مصدر جديد',
  EditJeSource: 'تعديل مصدر',

  JeCategories: 'تصنيفات القيود',
  AddJeCategory: 'إضافة تصنيف جديد',
  EditJeCategory: 'تعديل التصنيف',

  Tax: 'ضريبة القيمة المضافة',
  TaxType: 'نوع الضريبة',
  TaxRate: 'نسبة الضريبة',
  TaxCategory: 'الفئة الضريبية',
  AddNewTax: 'إضافة ضريبة جديدة',
  EditTax: 'تعديـل ضريبة',

  Companies: 'الشركات',
  Branches: 'الفروع',
  CostCenters: 'مراكز التكلفة',
  AdministrativeEntity: 'الجهة الإدارية',
  FinancialAccount: 'الحساب المالي',
  MainAccount: 'الحساب الرئيسي',
  Actions: 'الإجراءات',
  NotLinked: 'غير مرتبط',
  Link: 'ربط',
  RemoveLink: 'إزالة الربط',
  DepartmentsLinking: 'الربط بين الإدارات',
  LinkingAdministrativeEntityToAccounts: 'ربط الجهة الإدارية بالحسابات',

  NewExpenseType: 'نوع مصروف جديد',

  NameBank: 'اسم البنك',
  NoBank: 'رقم حساب البنك',
  Iban: 'رقم الأيبان',
  'Button.Edit': 'تعديل',
  BankAccounts: 'الحسابات البنكية',
  Bank: 'البنك',
  NewBankAccount: 'حساب بنكي جديد',
  AddBankAccount: 'إضافة حساب بنكي جديد',
  EditBankAccount: 'تعديل حساب بنكي',

  CloseSessionConfirmation: 'هل ترغب في إغلاق الجلسة بمبلغ إجمالي قدره ({{amount}})؟',
  SessionClosedSuccessfully: 'تم إغلاق الجلسة بنجاح.',

  CashBoxes: 'صناديق النقدية',
  NewCashBox: 'صندوق نقدية جديد',
  AddCashBox: 'إضافة صندوق نقدية جديد',
  EditCashBox: 'تعديل صندوق نقدية',
  CodeCannotContainSpaces: 'لا يُسمح بوجود فراغات في الكود',

  maxPerCustomerLabel: 'أقصى عدد مسموح للعميل',
  maxPerCustomerHelp: 'إذا كانت القيمة 0، فهذا يعني عدد غير محدود.',
  itemsSelectHint: 'عدم تحديد أي أصناف يعني شمول الجميع.',
  posSelectHint: 'عدم تحديد نقاط بيع يعني شمول الجميع.',
  MustBeZeroOrMore: 'يجب أن يكون صفرًا أو أكثر',
  MustBeOneOrMore: 'يجب أن يكون واحدًا أو أكثر',
  'Must be greater than 0': 'يجب أن يكون أكبر من 0',
  'At least one free item required': 'مطلوب عنصر مجاني واحد على الأقل',
  SelectItems: 'حدد الأصناف',

  Registered: 'مسجل',
  Unregistered: 'غير مسجل',
  RegistrationRequest: 'طلب تسجيل',
  Unknown: 'غير معروف',
  IsActive: 'نشط',

  SessionOpen: 'الجلسـة مفتوحة',
  SessionClosed: 'الجلسة غير مفتوحة',
  PointOfSaleName: 'اسم نقطة البيع',
  AffiliatedBranch: 'الفرع التابع له',
  LinkedInventory: 'المخزن المرتبط',
  SessionStatus: 'حالة الجلسة',
  RegistrationStatus: 'حالة التسجيل',
  SessionManagerName: 'اسم مسؤول الجلسة',

  PointOfSaleSettings: 'إعدادات نقاط البيع',
  NewPointOfSale: 'نقطة بيع جديدة',
  ApprovePointOfSaleRegistration: 'الموافقة على تسجيـل نقطة البيـع',

  OperatingUnit: 'وحدة التشغيل',
  ShowProductImage: 'عرض صورة المنتج',
  ShowCategory: 'عرض الفئة',
  AlternativeItems: 'الأصـناف البديلة',
  PromotionalOffers: 'العروض الترويجية',
  CashCustomer: 'العميـل النقدي',
  PointOfSaleInformation: 'معلومات نقطة البيع',
  InvoiceHeader: 'رأس الفاتورة',
  InvoiceFooter: 'تذييل الفاتورة',

  Cashier: 'الكاشيــر',
  AddCashier: 'إضــافة كاشيــر',
  CashierName: 'اسم الكاشيـر',
  DeleteItem: 'حذف صنف',
  UpdatePrice: 'تعديل سـعر',
  ReturnInvoice: 'إسترداد فاتورة',
  Activated: 'مفعل',
  Deactivated: 'غير مفعل',
  EditCashier: 'تعديـل كاشير',
  Info: 'معلومات',
  NotSpecified: 'غير محدد',

  PointsOfSale: 'نقاط البيع',
  PointOfSaleDetails: 'تفاصيل نقطة البيع',

  UpdatePricePermission: 'صلاحية تعديل السعر',
  DeleteItemPermission: 'صلاحية حذف صنف',
  ReturnInvoicePermission: 'صلاحية إسترداد فاتورة',
  PaymentMethods: 'طرق الدفع',
  AddPaymentMethod: 'إضــافة طريقة دفع',
  PointOfSale: 'نقطة البيع',
  AlreadyAdded: 'تمت اضافتها مسبقا',

  PosRegistration: 'تسجيل نقطة البيــع',
  Deleting: 'جاري الحذف...',
  DeleteDeviceRegistration: 'حذف تسجيل الجهاز',
  OperatingSystem: 'نظام التشغيل',
  DeviceType: 'نوع الجهاز',
  DeviceId: 'رقم الجهاز',
  ThisPosNotRegistered: 'نقطة البيع هذه غير مسجلة.',
  LoadingDeviceDetails: 'جاري تحميل تفاصيل الجهاز...',
  PosRegistrationDeletedSuccessfully: 'تم حذف تسجيل نقطة البيع بنجاح.',
  FailedToDeletePosRegistration: 'فشل في حذف تسجيل نقطة البيع.',
  UnexpectedError: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  Approved: 'تمت الموافقة',
  Rejected: 'مرفوض',
  PendingApproval: 'في انتظار الموافقة',
  ConfirmDeletePosRegistration: 'هل أنت متأكد أنك تريد حذف تسجيل نقطة البيع هذه؟',

  AssemblyItem: 'صنف مجمع',
  FixedAssetItem: 'صنف أصل ثابت',
  ExpenseItem: 'صنف مصروف',

  TotalItems: 'إجمالي الأصناف',
  InventoryItems: 'أصناف مخزنية',
  ServiceItems: 'أصناف خدمات',
  AssemblyItems: 'أصناف مجمعة',

  ItemsRegister: 'قائمة الأصناف',

  SearchItemsPlaceholder: 'ابحث باسم الصنف أو الكود أو الباركود...',
  ClearSearch: 'مسح البحث',
  SearchFilters: 'فلاتر البحث',

  NoSearchResults: 'لا توجد نتائج للبحث',
  NoItemsRegistered: 'لا توجد أصناف مسجلة',

  ShowingItems: 'عرض {{shown}} من {{total}} صنف',
  SearchResultsFor: 'نتائج البحث عن: "{{term}}"',

  SortResults: 'ترتيب النتائج',
  SearchFiltersAndSorting: 'فلاتر البحث والترتيب',

  FilterSettings: 'إعدادات الفلاتر',
  AddFilter: 'إضافة فلتر',
  NoFiltersAdded: 'لا توجد فلاتر مضافة',
  AddFilterHint: 'انقر على "إضافة فلتر" لبدء إنشاء شروط البحث',
  SelectFieldPlaceholder: 'اختر الحقل...',
  DeleteFilter: 'حذف الفلتر',

  SortSettings: 'إعدادات الترتيب',
  AddSort: 'إضافة ترتيب',
  NoSortsAdded: 'لا توجد ترتيبات مضافة',
  AddSortHint: 'انقر على "إضافة ترتيب" لبدء إنشاء شروط الترتيب',
  SelectSortFieldPlaceholder: 'اختر حقل الترتيب...',
  DeleteSort: 'حذف الترتيب',

  SelectFieldFirst: 'اختر حقل أولاً',
  EnterNumber: 'أدخل رقماً',
  EnterSearchValue: 'اكتب قيمة البحث',
  // Select: 'اختر',
  // Yes: 'نعم',
  // No: 'لا',

  SortAscendingOption: '↗ ترتيب تصاعدي (من الأصغر إلى الأكبر)',
  SortDescendingOption: '↘ ترتيب تنازلي (من الأكبر إلى الأصغر)',

  ActiveFiltersLabel: 'الفلاتر النشطة:',
  Reset: 'إعادة التعيين',
  ApplyFilters: 'تطبيق الفلاتر',
  Applying: 'جاري التطبيق...',

  OpEquals: 'يساوي',
  OpNotEquals: 'لا يساوي',
  OpGreaterThan: 'أكبر من',
  OpGreaterOrEqual: 'أكبر من أو يساوي',
  OpLessThan: 'أصغر من',
  OpLessOrEqual: 'أصغر من أو يساوي',
  OpContains: 'يحتوي على',
  OpStartsWith: 'يبدأ بـ',
  OpEndsWith: 'ينتهي بـ',

  //  Standard: 'قياسي',
  Custom: 'مخصص',
  StandardReport: 'تقرير قياسي',
  CustomReport: 'تقرير مخصص',

  ReportsCountLabel: '{{count}} تقرير',

  SearchReportsPlaceholder: 'ابحث باسم التقرير أو اسم الوحدة...',

  NoReportsFound: 'لا توجد تقارير مطابقة',
  TryDifferentSearch: 'جرب بحثاً مختلفاً',
  NoReportsAvailable: 'لا توجد تقارير متاحة',
  ShowAllReports: 'عرض كل التقارير',

  ClosePreview: 'إغلاق المعاينة',

  WelcomeReportManagerTitle: 'مرحباً في مدير التقارير',
  WelcomeReportManagerDescription:
    'اختر تقريراً من القائمة الجانبية لمعاينته. يمكنك تصفح التقارير القياسية أو المخصصة حسب احتياجاتك.',

  ReportFilters: 'فلاتر التقرير',
  ReportResults: 'نتائج التقرير',

  // ClearAll: 'مسح الكل',
  LoadData: 'تحميل البيانات',
  LoadingDataShort: 'جاري التحميل...',

  LoadingReportDataTitle: 'جاري تحميل البيانات',
  PleaseWait: 'يرجى الانتظار...',

  ReportRecordsCount: '{{count}} سجل',
  LastUpdateTime: 'آخر تحديث: {{time}}',

  NoReportDataTitle: 'لا توجد بيانات',
  NoReportDataDescription: 'قم بتعيين الفلاتر المطلوبة وانقر على زر "تحميل البيانات" لعرض نتائج التقرير.',

  InventoryTransactionStartTitle: 'بدء حركة مخزنية جديدة',
  InventoryTransactionStartSubtitle: 'اختر نوع الحركة المخزنية المناسبة',

  NoTransactionTypesAvailable: 'لا توجد أنواع حركة متاحة',
  CheckPermissionsOrSettings: 'يرجى التحقق من الصلاحيات أو إعدادات النظام',

  BackToTransactionTypeSelection: 'العودة لاختيار نوع الحركة',

  SelectOperatingUnitPlaceholder: 'اختر الوحدة التشغيلية',
  SelectInventoryPlaceholder: 'اختر المخزن',

  FetchData: 'جلب البيانات',
  FetchingData: 'جاري التحميل...',

  ReferenceFetchErrorMessage: 'حدث خطأ في جلب البيانات. يرجى المحاولة مرة أخرى.',

  NoReferenceDataTitle: 'لا توجد بيانات متاحة',
  NoReferenceDataDescription: 'لم يتم العثور على أي مراجع لهذا النوع من الحركة',

  StartTransaction: 'بدء الحركة',
  CompleteSelections: 'أكمل الاختيارات',

  TransType_RFG_Title: 'استلام منتج نهائي من الإنتاج',
  TransType_MOR_Title: 'استلام مواد من أمر تحويل',
  TransType_MIR_Title: 'إضافة مواد للمخزن',
  TransType_POR_Title: 'أمر شراء مواد',
  TransType_CRT_Title: 'مرتجع مبيعات عام',
  TransType_CRP_Title: 'مرتجع مبيعات نقاط البيع',
  TransType_INV_Title: 'فاتورة مبيعات',
  TransType_SOI_Title: 'أمر بيع',
  TransType_SOP_Title: 'أمر بيع من نقاط البيع',
  TransType_MOI_Title: 'أمر تحويل بين المخازن',
  TransType_SPR_Title: 'مرتجع مشتريات عام',
  TransType_SRP_Title: 'مرتجع مشتريات من أمر شراء',
  TransType_BIL_Title: 'فاتورة مشتريات',
  TransType_IOR_Title: 'استلام تحويل وارد',
  TransType_WOI_Title: 'أمر صيانة',
  TransType_CCA_Title: 'صرف مواد',
  TransType_MII_Title: 'إضافة جرد',

  TransTypeName_POR: 'أوامر الشراء',
  TransTypeName_INV: 'فواتير المبيعات',
  TransTypeName_CRT: 'مرتجعات المبيعات',
  TransTypeName_CRP: 'مرتجعات نقاط البيع',
  TransTypeName_MOR: 'أوامر التحويل',
  TransTypeName_IOR: 'استلام تحويل',
  TransTypeName_BIL: 'فواتير المشتريات',
  TransTypeName_MIR: 'أسباب الإضافة',
  TransTypeName_MII: 'أسباب الإضافة (جرد)',
  TransTypeName_CCA: 'أسباب الصرف',
  TransTypeName_SOI: 'أوامر البيع',
  TransTypeName_SOP: 'أوامر نقاط البيع',
  TransTypeName_MOI: 'أوامر التحويل',
  TransTypeName_WOI: 'أوامر الصيانة',
  ReferencesTitle: 'المراجع',

  LoadingPurchaseOrders: 'جاري تحميل أوامر الشراء...',

  PurchaseOrdersList: 'قائمة أوامر الشراء',

  SearchPurchaseOrdersPlaceholder: 'ابحث في أوامر الشراء (رقم الأمر، المورد، المبلغ، التاريخ...)',

  OrderDate: 'تاريخ الأمر',

  MatchesSearch: 'مطابق للبحث',

  PurchaseOrdersFilteredCount: '{{filtered}} من {{total}} أمر شراء',
  SearchTermLabel: 'بحث عن',

  NoSearchResultsTitle: 'لا توجد نتائج للبحث',
  NoPurchaseOrdersMatchSearch: '"{{term}}" - لم يتم العثور على أوامر شراء تطابق البحث',
  ClearSearchAndShowAll: 'مسح البحث وعرض الكل',

  PurchaseOrdersFooterSummary: 'عرض {{filtered}} من {{total}} أمر شراء',
  SearchedFor: 'تم البحث عن:',

  LoadingReasons: 'جاري تحميل الأسباب...',

  Reasons_GenericTitle: 'الأسباب',
  Reasons_IssueTitle: 'أسباب الصرف',
  Reasons_ReceiptTitle: 'أسباب الإضافة',

  ReasonsListTitle: 'قائمة {{reasonType}}',
  ReasonName: 'اسم السبب',
  ReasonDescription: 'الوصف',

  ReasonsFooterSummary: 'عرض {{count}} من {{total}} سبب',

  LoadingSalesInvoices: 'جاري تحميل الفواتير...',

  SalesInvoicesListTitle: 'قائمة أوامر البيع',

  LoadingSupplierReturns: 'جاري تحميل مردودات الشراء...',

  SupplierReturnsListTitle: 'قائمة مردودات الشراء',
  SupplierReturnsSearchPlaceholder: 'ابحث في المردودات (الرقم، المورد، المبلغ، التاريخ...)',

  SupplierReturnsFilteredCount: '{{filtered}} من {{total}} مردود',
  NoSupplierReturnsMatchSearch: '"{{term}}" - لم يتم العثور على مردودات تطابق البحث',
  SupplierReturnsFooterSummary: 'عرض {{filtered}} من {{total}} مردود',

  LoadingTransferOrders: 'جاري تحميل أوامر التحويل...',

  TransferOrdersListTitle: 'قائمة أوامر التحويل',

  InboundInventory: 'المخزن الوارد',
  TransferOrderDefaultName: 'أمر تحويل',

  TransferOrdersFooterSummary: 'عرض {{count}} من {{total}} أمر تحويل',

  LoadingWorkOrders: 'جاري تحميل أوامر الصيانة...',

  WorkOrdersListTitle: 'قائمة أوامر الصيانة',

  WorkOrdersFooterSummary: 'عرض {{count}} من {{total}} أمر صيانة'
};

export default translation;
